<img
    [src]="src"
    [style.object-fit]="fitContent"
    [style.width]="width"
    [style.height]="height"
    [style.min-height]="minHeight"
    [style.min-width]="minWidth" 
    [style.borderWidth.px]="borderWidth"
    [class]="customClass"
    (load)="loading = false"
    (error)="emitError()"
/>
<ngx-skeleton-loader
    *ngIf="loading"
    class="absolute inset-0"
    [class]="customClass"
    [theme]="{
        width: '100%',
        height: '100%',
        marginBottom: '0',
        borderRadius: 'inherit',
    }"    
/>
